import { PeriodType } from "hassibot/component/cost-simulator/types";
import { ServiceUuid } from "hassibot/services_v2/common/types";
import {
  QuoteDocumentCart,
  QuoteDocumentCartOhpProductType,
  TransientQuoteDocumentCartOhProductTypes,
} from "hassibot/services_v2/document/types";
import { ProclientVebEvaluationNeedType } from "hassibot/services_v2/veb-evaluation/types";

import {
  Frequency,
  NeedTypeAndOhProduct,
  needTypeCategory,
  NeedTypeCategory,
  NeedTypeQuantityPerProduct,
} from "./types";

export const DAYS_IN_WEEK = 7;

export const DEFAULT_CART_PRODUCTS: QuoteDocumentCart = {
  ohPackages: {
    agitatedNightPackage: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    agitatedNightPackageIn24H: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    calmNightPackage: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    day10HPackage: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    day12HPackage: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    perHour: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
    calmNightPackageIn24H: { week: 0, weekend: 0, night: 0, nightAndWeekend: 0 },
  },
  ohpPackages: {
    "06d21479-bbec-492f-ac20-4fa896709b59": 0,
    "08ae6bf1-d9f5-4808-b969-c3722e057d10": 0,
    "d24b2c5f-7d63-4974-9811-e45a0d0180ba": 0,
    "280b1f0c-f978-4813-a731-4f3b741efc56": 0,
  },
  ohPackagesComment: "",
  ohpPackagesComment: "",
};

export const NEED_TYPE_TO_OH_PRODUCT_QUANTITY: NeedTypeAndOhProduct[] = [
  {
    label: "nuit et jour",
    frequency: Frequency.DAILY,
    needTypes: [
      ProclientVebEvaluationNeedType.DAY_CONTINUOUS_PRESENCE,
      ProclientVebEvaluationNeedType.NIGHT_PRESENCE,
    ],
    ohPackages: ["calmNightPackageIn24H", "day12HPackage"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: false,
  },
  {
    label: "nuit calme",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.NIGHT_PRESENCE],
    ohPackages: ["calmNightPackage"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "journée",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.DAY_CONTINUOUS_PRESENCE],
    ohPackages: ["day12HPackage"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: false,
  },
  {
    label: "aide à la toilette",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.WASHING],
    ohPackages: ["perHour"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide au ménage",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.HOUSE_KEEPING],
    ohPackages: ["perHour"],
    quantity: { week: 2, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide au coucher",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.GO_TO_BED],
    ohPackages: ["perHour"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide au lever",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.GET_OUT_OF_BED],
    ohPackages: ["perHour"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide aux courses",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.SHOPPING],
    ohPackages: ["perHour"],
    quantity: { week: 2, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide à la préparation de repas",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.MEAL_PREPARATION],
    ohPackages: ["perHour"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide au repas",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.MEAL_INTAKE],
    ohPackages: ["perHour"],
    quantity: { week: 5, weekend: 2, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "aide au change",
    frequency: Frequency.DAILY,
    needTypes: [ProclientVebEvaluationNeedType.CHANGE],
    ohPackages: ["perHour"],
    quantity: { week: 15, weekend: 6, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "stimulation cognitive",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.COGNITIF_STIMULATION],
    ohPackages: ["perHour"],
    quantity: { week: 2, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "stimulation physique",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.PHYSICAL_STIMULATION],
    ohPackages: ["perHour"],
    quantity: { week: 2, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "compagnie",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.COMPANY],
    ohPackages: ["perHour"],
    quantity: { week: 2, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
  {
    label: "sortie",
    frequency: Frequency.WEEKLY,
    needTypes: [ProclientVebEvaluationNeedType.OUTING],
    ohPackages: ["perHour"],
    quantity: { week: 3, weekend: 0, night: 0, nightAndWeekend: 0 },
    isCumulative: true,
  },
];

export const NEED_TYPE_TO_OHP_PRODUCT_QUANTITY: {
  needTypes: ProclientVebEvaluationNeedType[];
  ohpPackages: ServiceUuid[];
}[] = [
  {
    needTypes: [
      ProclientVebEvaluationNeedType.DAY_CONTINUOUS_PRESENCE,
      ProclientVebEvaluationNeedType.NIGHT_PRESENCE,
    ],
    ohpPackages: ["6124d5e4-601b-262d-6671-e8ceae0ec9e5"], // Commandes protections hygiéniques
  },
  {
    needTypes: [ProclientVebEvaluationNeedType.SHOPPING],
    ohpPackages: ["57dcc8e0-cb58-15ba-ed3c-13ec62abf747"],
  },
];

export const TRANSIENT_PRICE_SIMULATION_OH_PRODUCTS_HOURS: Record<
  TransientQuoteDocumentCartOhProductTypes & QuoteDocumentCartOhpProductType,
  number
> = {
  perHour: 1,
  day10HPackage: 10,
  day12HPackage: 12,
  calmNightPackage: 12,
  agitatedNightPackage: 12,
  calm24HPackage: 24,
  agitated24HPackage: 24,
  calmNightPackageIn24H: 12,
  agitatedNightPackageIn24H: 12,
};

// # This value is set to 4 and not 52/12 on purpose for quotation
export const NB_WEEKS_BY_MONTH = 4;
export const WEEK_END_SURCHARGE_MULTIPLICATOR = 1.2;
export const NIGHT_SURCHARGE_MULTIPLICATOR = 1.2; // oh+ pricing is set here because we can't retrieve it from pricing strategy template

export const PRICE_SIMULATION_OHP_PRODUCTS_PRICES: Record<QuoteDocumentCartOhpProductType, number> =
  {
    "d24b2c5f-7d63-4974-9811-e45a0d0180ba": 7900,
    "06d21479-bbec-492f-ac20-4fa896709b59": 19900,
    "08ae6bf1-d9f5-4808-b969-c3722e057d10": 34900,
    "280b1f0c-f978-4813-a731-4f3b741efc56": 3000,
  };

export const PeriodTypeToNbWeek: Record<PeriodType, number> = {
  [PeriodType.WEEKLY]: 1,
  [PeriodType.MONTHLY]: NB_WEEKS_BY_MONTH,
};

// this is only built for per hour products
export const NEED_TYPE_TO_CATEGORY: Partial<
  Record<ProclientVebEvaluationNeedType, NeedTypeCategory>
> = {
  [ProclientVebEvaluationNeedType.COGNITIF_STIMULATION]: needTypeCategory.STIMULATION,
  [ProclientVebEvaluationNeedType.PHYSICAL_STIMULATION]: needTypeCategory.STIMULATION,
  [ProclientVebEvaluationNeedType.COMPANY]: needTypeCategory.STIMULATION,
  [ProclientVebEvaluationNeedType.OUTING]: needTypeCategory.STIMULATION,
  [ProclientVebEvaluationNeedType.MEAL_INTAKE]: needTypeCategory.MEAL,
  [ProclientVebEvaluationNeedType.MEAL_PREPARATION]: needTypeCategory.MEAL,
  [ProclientVebEvaluationNeedType.GET_OUT_OF_BED]: needTypeCategory.MORNING,
  [ProclientVebEvaluationNeedType.WASHING]: needTypeCategory.MORNING,
};

// this is only built for per hour products
export const NEED_TYPE_TO_MAX_QUANTITY: Record<
  NeedTypeCategory,
  Partial<NeedTypeQuantityPerProduct>
> = {
  [needTypeCategory.MORNING]: {
    perHour: { week: 7.5, weekend: 3, night: 0, nightAndWeekend: 0 },
  },
  [needTypeCategory.MEAL]: {
    perHour: { week: 7.5, weekend: 3, night: 0, nightAndWeekend: 0 },
  },
  [needTypeCategory.STIMULATION]: {
    perHour: { week: 3, weekend: 0, night: 0, nightAndWeekend: 0 },
  },
};

export const categoryToLabel: Record<NeedTypeCategory, string> = {
  [needTypeCategory.MORNING]: "Aide matinale",
  [needTypeCategory.MEAL]: "Aide au repas",
  [needTypeCategory.STIMULATION]: "Stimulation",
};

export const SUPPORT_EMAIL = "support@groupe.ouihelp.fr";

export const centsToEuros = (cents: number): number => cents / 100;
